import { SET_IS_PAYING, SET_IS_CORP_DIALOG_OPENED } from './actionsTypes'

const initialState = {
  isPaying: false,
  isCorpDialogOpened: false,
}

const sharedFlags = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_IS_PAYING:
      return {
        ...state,
        isPaying: payload,
      }
    case SET_IS_CORP_DIALOG_OPENED:
      return {
        ...state,
        isCorpDialogOpened: payload,
      }
    default:
      return state
  }
}

export default sharedFlags
